import { Button, Stack, Form } from "react-bootstrap";

const PaginationControls = ({ currentPage, totalPages, limit, onPageChange, onLimitChange }) => {
    return (
        <Stack direction="horizontal" gap={3} className="my-4 justify-content-end">
            <div className="d-flex align-items-center gap-2 mb-4 mt-4">
                <Button
                    variant="outline-primary"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </Button>

                <span className="mx-2"> Page {currentPage} of {totalPages} </span>

                <Button
                    variant="outline-primary"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </Button>
            </div>

            <Form.Select
                style={{ width: "100px" }}
                className="m-2"
                value={limit}
                onChange={(e) => onLimitChange(Number(e.target.value))}
            >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
            </Form.Select>
        </Stack>
    );
};

export default PaginationControls;